'use strict';

import config from '../../js/config';

var utilities = require('../../js/utilities'),
  $ = require('jquery'),
  _ = require('underscore'),
  Backbone = require('backbone'),
  UrlData,
  REGEX_UP_TO_QUERY_STRING = /^([^?]+)/;

UrlData = Backbone.Model.extend({

  defaults: {
    page: 1,
    q: ''
  },

  initialize: function() {
    if (this.get('apiUrlString')) {
      this.setInitialState();
    } else {
      this.originalDataObject = {};
      this.displayUrlData = {};
      this.unset('apiUrlString'); // Is this needed as the if says it does not have apiUrlString
    }
  },

  setInitialState: function() {
    this.totalReset();
    this.resetFilters();
    this.resetPerPageResultsCount();

    this.displayUrlData = this.getQueryParameters(this.getDocumentLocation().search.replace(/\+/g, '%20').replace(/&amp;/g, '&'));
    let qstring = this.get('apiUrlString');
    if (qstring) {
      let qparams = this.getQueryParameters(qstring.replace(/\+/g, '%20'));
      if (!qparams.page) {
        qparams.page = 1;
      }

      this.set(qparams);
    } else if (this.displayUrlData) {
      this.set(this.displayUrlData);
    }

    this.originalDataObject = $.extend(true, {}, this.attributes);

    this.unset('apiUrlString');

  },

  getDocumentLocation: function() {
    return document.location;
  },

  getQueryParameters: function(params) {

    if (!params) {
      return false;
    }

    // Turn qs in to object
    params = utilities.deserialize(params);

    // Use the url fragment if history is not supported
    if (!Modernizr.history) {
      // Get qs as object from url fragment
      var fragmentParams = utilities.deserialize(this.getDocumentLocation().hash.replace(REGEX_UP_TO_QUERY_STRING, ''));

      // Override qs with url fragment values
      if (fragmentParams) {
        params = _.defaults(fragmentParams, params);
      } else if (!params) {
        params = fragmentParams;
      }
    }

    return params;
  },

  setDefaultSearch: function() {
    if (!this.get('q')) {
      this.set('q', '', { silent: true });
    }
  },

  resetPage: function() {
    this.set('page', 1);
    return this.get('page');
  },

  resetSort: function() {
    this.unset('sort');
  },

  resetFilterGroup: function(filterGroup) {
    if (this.has('filters')) {
      var updatedFilters = _.clone(this.get('filters'));
      delete updatedFilters[filterGroup];
      this.set('filters', updatedFilters);
    }
  },

  resetFilters: function() {
    if (this.has('filters')) {
      this.unset('filters');
    }
  },

  resetPerPageResultsCount: function() {
    if (this.has('perPage')) {
      this.unset('perPage');
    }
  },

  totalReset: function() {
    this.setDefaultSearch();
    this.resetPage();
    this.resetSort();
    this.resetFilterGroup();
  },

  retrieveData: function() {

    if (!this.has('filters')) {
      // delete this.data.filters;
      return this.toJSON();
    } else {
      let npi = this.separateNpi(this.toJSON());
      return utilities.parseFilterString(this.splitInStock(npi));
    }

  },

  separateNpi(obj) {

    if (!obj || !obj.filters) {
      return obj;
    }
    delete obj.filters.New;
    if (obj.filters.promoGroup) {
      let promoGroup = _.filter(obj.filters.promoGroup, item => item !== config.filters.new);
      if (promoGroup.length < obj.filters.promoGroup.length) {
        obj = $.extend(true, {}, obj);
        if (promoGroup.length) {
          obj.filters.promoGroup = promoGroup;
        } else {
          delete obj.filters.promoGroup;
        }
        obj.filters.New = ['true'];
      }
    }

    return obj;
  },

  splitInStock(obj) {
    if (!obj || !obj.filters) {
      return obj;
    }
    delete obj.filters.InStock;
    if (obj.filters.promoGroup) {
      let promoGroupInStock = _.filter(obj.filters.promoGroup, item => item.indexOf('Stock') < 0);
      if (promoGroupInStock && promoGroupInStock.length < obj.filters.promoGroup.length) {
        obj = $.extend(true, {}, obj);
        if (promoGroupInStock.length) {
          obj.filters.promoGroup = promoGroupInStock;
        } else {
          delete obj.filters.promoGroup;
        }
        obj.filters['In Stock'] = ['Yes'];
      }
    }
    return obj;
  },

  retrieveUrlDisplayData: function() {

    var changedUrlAttributes = this.mergeInitialUrlWithNewModel();

    if (!changedUrlAttributes.hasOwnProperty('filters')) {
      delete changedUrlAttributes.promoGroupLevel;
      return changedUrlAttributes;
    } else if ($.isEmptyObject(changedUrlAttributes.filters)) {
      delete changedUrlAttributes.filters;
      delete changedUrlAttributes.promoGroupLevel;
      return changedUrlAttributes;
    } else {
      let npi = this.separateNpi(this.separateNpi((changedUrlAttributes)));
      return utilities.parseFilterString(this.splitInStock(npi));
    }

  },

  mergeInitialUrlWithNewModel: function() {

    var urlData = {};

    for (var attrname in this.attributes) {
      //Check if it exists in the original.
      if (this.originalDataObject.hasOwnProperty(attrname)) {
        if (attrname !== 'filters') {
          //If it's not a filter, and it's changed, create a new key
          if (this.originalDataObject[attrname] !== this.attributes[attrname]) {
            urlData[attrname] = encodeURIComponent(this.attributes[attrname]);
          } else {
            //If it's not a filter, it hasn't changed, but it existed in the original display object, create a new key
            if (this.originalDataObject[attrname] === this.displayUrlData[attrname]) {
              urlData[attrname] = encodeURIComponent(this.attributes[attrname]);
            }
          }
        } else {
          //If it's a filter, loop the items and check if there's any pre-existing filters
          for (var filter in this.attributes[attrname]) {
            //if the filter exists in the original data object then....
            if (this.originalDataObject[attrname].hasOwnProperty(filter)) {
              var filterArray = [];
              //loop through the filter names and check if they existed before.
              for (var i = 0; i < this.attributes[attrname][filter].length; i++) {
                if (this.originalDataObject[attrname][filter].indexOf(this.attributes[attrname][filter][i]) < 0) {
                  //if it doesn't exist, add it the array ready to display in the URL
                  filterArray.push(encodeURIComponent(this.attributes[attrname][filter][i]));
                  //if it does exist, and it existed in the orignal url Data
                } else if (this.displayUrlData.hasOwnProperty(attrname)) {
                  if (this.displayUrlData[attrname].hasOwnProperty(filter)) {
                    if (this.displayUrlData[attrname][filter].indexOf(this.attributes[attrname][filter][i]) >= 0) {
                      filterArray.push(encodeURIComponent(this.attributes[attrname][filter][i]));
                    }
                  }
                }
              }
              //Apply to url object.
              if (filterArray.length > 0) {
                urlData[attrname] = urlData[attrname] || {};
                urlData[attrname][filter] = filterArray;
              }
            } else {
              urlData[attrname] = urlData[attrname] || {};
              urlData[attrname][filter] = _.map(this.attributes[attrname][filter], encodeURIComponent);
            }
          }
        }
      } else {
        //If it doesn't exist in the original, apply it to the new object.
        urlData[attrname] = this._encode(this.attributes[attrname]);
      }
    }

    //Remove page parameter from the URL when it's the first one for SEO
    if (urlData.page && urlData.page === '1') {
      delete urlData.page;
    }

    //Remove page parameter from the URL if the query is empty for SEO
    if (!urlData.q) {
      delete urlData.q;
    }
    return urlData;
  },

  _encode: function(val) {
    if (_.isObject(val)) {
      return _.mapObject(val, this._encodeArrayOrString);
    }

    return this._encodeArrayOrString(val);
  },

  _encodeArrayOrString: function(val) {
    if (_.isArray(val)) {
      return _.map(val, encodeURIComponent);
    }

    return encodeURIComponent(val);
  }
});

module.exports = UrlData;



// WEBPACK FOOTER //
// ./assets/components/Search/urlModel.js